import { render, staticRenderFns } from "./searchAPFilterWH.vue?vue&type=template&id=bb38cbd6&scoped=true&"
import script from "./searchAPFilterWH.vue?vue&type=script&lang=js&"
export * from "./searchAPFilterWH.vue?vue&type=script&lang=js&"
import style0 from "./searchAPFilterWH.vue?vue&type=style&index=0&id=bb38cbd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb38cbd6",
  null
  
)

component.options.__file = "searchAPFilterWH.vue"
export default component.exports